// extracted by mini-css-extract-plugin
export default {"profile":"Profile--profile--LhJyeeVe","edit":"Profile--edit--R8Ql5G0u","editContainer":"Profile--editContainer--jbL7r3LK"};